export default "__VITE_ASSET__DrCboPuk__"